<div class="col-sm-2 vendors-filter">
    <div class="vendors-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <spinner [spinnerShow]="showDropdown && directoryService.vendorsCategories.length < 1"></spinner>
    <div class="vendors-filter_dropdown" [hidden]="!showDropdown || directoryService.vendorsCategories.length < 1">
        <div class="vendors-filter-items-wrapper">
            <div class="m-b-xs filter-checkbox" *ngFor="let category of directoryService.vendorsCategories; let index = index;">
                <label class="img-checkbox">
                    <input type="checkbox" id="{{category.id}}" [attr.checked]="category.checked ? '' : null" (change)="timeOutBeforeFilterChanging()">
                    <label for="{{category.id}}"><svg-checked></svg-checked></label>
                    <span>{{category.name}}</span>
                </label>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/vendors-filter/vendors-filter.component.html